import { Typography, type TypographyProps } from "@octopus-energy/coral/atoms"

export function PageStepNumber(props: Omit<TypographyProps, "textAlign" | "textStyle" | "color">) {
    return (
        <Typography
            textAlign="center"
            textStyle="h5"
            color="tertiary500"
            {...props}
        />
    )
}
